import { observer } from 'mobx-react-lite'
import { useBreakdownFilterContext } from 'pages/analytics/ui/BreakdownFilter/context/breakdownFilterContext'
import { BreakdownFilterTypesContent } from './BreakdownFilterTypesContent'
import { BreakdownFilterEditorContent } from './BreakdownFilterEditorContent'

type IBreakdownFilterDropdownContentProps = {
  parentsDropdownId?: string[]
}

export const BreakdownFilterDropdownContent = observer(
  ({ parentsDropdownId }: IBreakdownFilterDropdownContentProps) => {
    const { hasFilters } = useBreakdownFilterContext()

    if (hasFilters) {
      return <BreakdownFilterEditorContent parentsDropdownId={parentsDropdownId} />
    }

    return <BreakdownFilterTypesContent />
  }
)
